import React, { FC } from "react";
import { FlattenedOrderItem } from "../../utils/orderhelpers";
import { Table } from "antd";

type Props = {
  flatOrderItems: FlattenedOrderItem[];
};
const OrderItemList: FC<Props> = ({ flatOrderItems }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Rate",
      key: "rate",
      dataIndex: "rate",
    },
    {
      title: "Amount",
      key: "amount",
      dataIndex: "amount",
    },
  ];

  return (
    <Table
      dataSource={flatOrderItems}
      columns={columns}
      pagination={false}
      size="small"
    />
  );
};

export default OrderItemList;
